module.exports = __webpack_public_path__ + "img/bg-home-persona-2.cd8326b.png";